import React from 'react';
import { SelfTestQuestion } from './model/SelfTestQuestion';
import { UrlService } from '../../core/services/UrlService';

type Props = {
    id: string,
    q: SelfTestQuestion;
    onAnswerClicked: (answer?: string) => any;
}

const SelfTestTemplateMultipleChoiceQuestionContext: React.FC<Props> = (props: Props) => {
    const handleClick = (answer?: string) => {
        props.onAnswerClicked(answer);
    }

    return (
        <div id={props.id} className={`self-test__test-question q${props.id}`}>
            <div className="self-test__test-question-sizer">
                <div className="self-test__test-question-cover">
                    <img src={UrlService.getLocalImageUrl(props.q.image ?? "placeholder.png")} alt="" />
                </div>
                <div className="self-test__test-question-content">
                    <div className="self-test__test-question-pre-description-container"></div>
                    <p className="title" dangerouslySetInnerHTML={{ __html: props.q.title ?? "" }}></p>
                    <p className="content" dangerouslySetInnerHTML={{ __html: props.q.content ?? "" }}></p>
                    <div className="options">
                        {props.q.answers?.map((x, index) => {
                            return (
                                <div key={index} className="option" onClick={() => { handleClick(x.answer); }}>
                                    <input className="input" name={x.label} type="radio" />
                                    <label className="label">
                                        <span>{x.label}</span>
                                    </label>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelfTestTemplateMultipleChoiceQuestionContext;
